import { Component, Inject, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { TokenizeFormComponent } from '../../../pages/terminal/tokenize-form/tokenize-form.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Logging } from '../../../core/logging';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-tokenize-dialog',
  templateUrl: './tokenize-dialog.component.html',
  standalone: false,
})
export class TokenizeDialogComponent {
  //@ViewChild(TokenizeFormComponent) tokenizeForm: TokenizeFormComponent | undefined;
  @ViewChild(TokenizeFormComponent) tokenizeForm:
    | TokenizeFormComponent
    | undefined;

  _merchantId: string;
  _customerId: string;
  loadingSpinnerRef: MatDialogRef<LoadingSpinnerComponent> | undefined;

  constructor(
    public dialogRef: MatDialogRef<TokenizeDialogComponent>,
    public sanitizer: DomSanitizer,
    public loadingSpinnerDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      customerId: string;
      merchantId: string;
      paymentType: string;
    },
  ) {
    this._merchantId = data.merchantId;
    this._customerId = data.customerId;
  }

  btnCancel_clicked() {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close();
  }

  btnSave_clicked() {
    this.loadingSpinnerRef = this.loadingSpinnerDialog.open(
      LoadingSpinnerComponent,
      {
        disableClose: true,
        panelClass: 'transparent-dialog',
        data: {
          mode: 'indeterminate',
        },
      },
    );
    if (this.tokenizeForm) {
      this.tokenizeForm?.tokenize();
    } else {
      throw 'tokenize form is not initialized';
    }
  }

  handleTokenizeFormValidationChanged(data: any) {
    if (data.isValid) {
    }
  }

  handleTokenized(tokenizationData: any) {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close(tokenizationData.paymentMethodId);
  }

  handleCancelled() {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close();
  }
}
